import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const InfoNote = ({ text }) => {
  return (
    <Box
      sx={{
        my: 5,
        px: 2,
        py: 1.5,
        display: "flex",
        alignItems: "flex-start",
        gap: 1.2,
        backgroundColor: "#fff",
        borderLeft: "4px solid #30B0C7",
        borderRadius: "8px",
      }}
    >
      <InfoOutlinedIcon sx={{ color: "#30B0C7", mt: "2px" }} />
      <Typography fontSize="18px" color="text.secondary" fontWeight={500}>
        {text}
      </Typography>
    </Box>
  );
};

export default InfoNote;
